import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { LogoNavConfig } from '../../../models/header-model';

@Component({
  selector: 'kw-logo-nav',
  templateUrl: './logo-nav.component.html',
  styleUrls: ['./logo-nav.component.scss']
})
export class LogoNavComponent implements OnInit {
  @Input() logoNavConfig:LogoNavConfig;
  storeName:string;
  showStoreName:boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["logoNavConfig"]){
      this.storeName = this.logoNavConfig.storeName;
      this.showStoreName = this.logoNavConfig.showStoreName;
    }
  }

}
